// extracted by mini-css-extract-plugin
export default {"input":"style_input__6PzkA","submitButton":"style_submitButton__3HfCH","cancelButton":"style_cancelButton__LkW2b"};